import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmr00200-wrapper" }
const _hoisted_2 = { class: "mx-auto cmr00200-form-area" }
const _hoisted_3 = { class: "col q-gutter-sm q-mb-sm" }
const _hoisted_4 = { class: "col q-gutter-sm q-mb-sm" }
const _hoisted_5 = { class: "col" }

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import { isEmpty, isValidateEmail, isHalfKana } from '../../common/utils/validateUtils';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMR00200',
  setup(__props) {

const router = useRouter();

// 登録確認フラグ
const isConfimationFlg = ref(false);

// アラートダイアログフラグ
const isAlertFlg = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// ユーザー姓
const userNameSei = ref('');
// ユーザー名
const userNameMei = ref('');
// メールアドレス
const mailAddress = ref('');
// メールアドレスエラーフラグ
const isMailAddressErr = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 会員登録
 */
const registerAdmin = async () => {
  isMailAddressErr.value = false;
  errMessage.value = '';
  isMessageChip.value = false;
  // Loading Start
  Loading.show();
  // 登録データ作成
  const formData = new FormData();
  formData.append('user_name_sei', userNameSei.value);
  formData.append('user_name_mei', userNameMei.value);
  formData.append('mail_address', mailAddress.value);

  // 管理者登録
  await axios
    .post('/cmr002001/administrator-register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.BAN_DOMAIN_ERROR:
            case DetailResultStatusCode.NOT_EMAIL_EXIST_ERROR:
            case DetailResultStatusCode.DUPLICATE_EMAIL_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              isMailAddressErr.value = true;
              break;

            // インサート、削除エラーの場合
            case DetailResultStatusCode.DELETE_ERROR:
            case DetailResultStatusCode.INSERT_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合

            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
        // エラー画面に遷移
      } else {
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[10] || (_cache[10] = [
        _createTextVNode("新規管理者登録")
      ])),
      _: 1
    }),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      novalidate: "",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (isConfimationFlg.value = true), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(MessageChip, {
            display: isMessageChip.value,
            level: "E",
            message: errMessage.value,
            onValidationError: resetError
          }, null, 8, ["display", "message"]),
          _createElementVNode("div", _hoisted_3, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "name",
              class: "requier"
            }, "お名前（姓）", -1)),
            _createVNode(_component_q_input, {
              modelValue: userNameSei.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userNameSei).value = $event)),
              outlined: "",
              maxlength: "100",
              dense: "",
              rules: [
              (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
              (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
            ],
              "lazy-rules": "",
              class: "input-area left-input",
              hint: "例）山田",
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "requier" }, "お名前（名）", -1)),
            _createVNode(_component_q_input, {
              modelValue: userNameMei.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userNameMei).value = $event)),
              outlined: "",
              dense: "",
              maxlength: "100",
              "bg-color": "white",
              rules: [
              (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
              (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
            ],
              "lazy-rules": "",
              class: "input-area left-input",
              hint: "例）太郎",
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "requier" }, "会員ID（メールアドレス）", -1)),
            _createVNode(_component_q_input, {
              modelValue: mailAddress.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mailAddress).value = $event)),
              outlined: "",
              type: "email",
              dense: "",
              maxlength: "254",
              rules: [
              (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
              (val) => _unref(isValidateEmail)(val) || _ctx.$t('validation.email'),
            ],
              "lazy-rules": "",
              class: "input-area left-input",
              hint: "例）example@xxx.com",
              error: isMailAddressErr.value,
              onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules", "error"])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col q-gutter-sm column" }, [
            _createElementVNode("label", null, "ユーザー権限"),
            _createElementVNode("span", { class: "q-ml-md" }, "管理者")
          ], -1))
        ]),
        _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
          "button-area": _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_q_btn, {
                color: "primary",
                outline: "",
                style: {"width":"120px"},
                class: "q-mr-xs",
                icon: "mdi-chevron-left",
                label: "戻る",
                to: { name: 'members' }
              }),
              _createVNode(_component_q_btn, {
                type: "submit",
                color: "primary",
                style: {"width":"120px"},
                label: "登録"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isConfimationFlg.value,
      level: "information",
      title: "登録確認",
      text: ['入力された内容で登録します。', 'よろしいですか？'],
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => ((isConfimationFlg.value = false), registerAdmin())),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (isConfimationFlg.value = false))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: isAlertFlg.value,
      level: "information",
      confirmation: "",
      title: "登録完了",
      text: ['新規管理者登録が完了しました。'],
      onComplete: _cache[9] || (_cache[9] = ($event: any) => (_unref(router).push({ name: 'members' })))
    }, null, 8, ["display"])
  ]))
}
}

})